/**
 * The app status bar (U13, A+B merge): a slim row across the bottom of the window, under the sidebar and the workspace,
 * shown only while it has something to report — today the Transfers chip, on its left (the toasts stack at the bottom
 * right and would cover it there). It takes its own row, so it never covers the sidebar's Scripts footer or a tab's
 * status bar (the chip used to float at the bottom-left corner, over both).
 */
import { selectOrderedJobs, TransfersStatusChip, useTransfersStore } from '../../features/transfers';

export function AppStatusBar() {
  const hasTransfers = useTransfersStore((state) => selectOrderedJobs(state).length > 0);
  if (!hasTransfers) return null;
  return (
    <div
      className="flex h-7 shrink-0 items-center justify-start gap-2 border-t border-border bg-muted/30 px-2 text-xs text-muted-foreground"
      aria-label="Status bar"
      role="group"
      data-testid="app-status-bar"
    >
      <TransfersStatusChip />
    </div>
  );
}
